/**
 * Triage status for a stored, deduped error. The backend stores the RAW status and consumers derive the effective
 * one: `active` is open and un-triaged, `ignored` stays muted forever regardless of new occurrences, and
 * `resolved` REGRESSES to active when an occurrence lands after `statusChangedAt` (see effectiveStatus in
 * errors.service.ts). Keep in sync with the `error_status` pgEnum in apps/server/src/common/db-schema.ts.
 */
export const ERROR_STATUSES = ['active', 'ignored', 'resolved'] as const
export type ErrorStatus = (typeof ERROR_STATUSES)[number]

/** Where an error was captured: a server-side 500 or an uncaught client (browser) error. */
export const ERROR_ORIGINS = ['server', 'client'] as const
export type ErrorOrigin = (typeof ERROR_ORIGINS)[number]
